export default {
    data() {
        return {
            mixPanelInstance: null
        }
    },
    methods: {
        trackMixpanelEvent(event, additionalProperties) {
            event = `Page Hit: ${event}`;
            this.mixPanelInstance.trackEvent(event, additionalProperties);
        }
    },
}